import { Base } from '@studiometa/js-toolkit';

/**
 * FormReset
 */
export default class FormReset extends Base {
  static config = {
    name: 'FormReset',
    options: {
      hard: Boolean,
      target: String,
    },
  };

  /**
   * Form targets
   * @returns {Array<HTMLFormElement>}
   */
  get targets() {
    return this.$options.target || this.$el.hasAttribute('form')
      ? Array.from(
          document.querySelectorAll(this.$options.target ?? `#${this.$el.getAttribute('form')}`),
        )
      : [this.$el.closest('form')];
  }

  /**
   * Is hard reset ?
   * @returns {boolean}
   */
  get isHard() {
    return this.$options.hard ?? false;
  }

  /**
   * On click
   */
  onClick() {
    this.targets.forEach((form) => {
      form.reset();

      if (!this.isHard) {
        return;
      }

      Array.from(form.querySelectorAll('select option[selected]'))
        .filter((item) => !item.dataset['ignore-hard-reset'])
        .forEach((option) => option.removeAttribute('selected'));

      Array.from(form.querySelectorAll('input[type="checkbox"], input[type="radio"]'))
        .filter((item) => !item.dataset['ignore-hard-reset'])
        .forEach((input) => input.removeAttribute('checked'));

      Array.from(form.querySelectorAll('input[type="text"], input[type="search"]'))
        .filter((item) => !item.dataset['ignore-hard-reset'])
        .forEach((input) => {
          input.value = '';
        });
    });
  }

  /**
   * Mounted
   */
  mounted() {
    if (this.targets.length <= 0) {
      this.$destroy();
    }
  }
}
